import { createContext } from "react";
import { GLOBAL_VARIABLES } from "constants/contexts.constants";

const GlobalVariablesContext = createContext(GLOBAL_VARIABLES);
GlobalVariablesContext.displayName = "GlobalVariables";
export default GlobalVariablesContext;
